<app-nav>
  <router-outlet></router-outlet>
</app-nav>
